module.exports = __webpack_public_path__ + "img/cloud-off.5d7eeb1b.svg";